import { render } from "./CreateInvoice.vue?vue&type=template&id=5f464d97&scoped=true"
import script from "./CreateInvoice.vue?vue&type=script&lang=js"
export * from "./CreateInvoice.vue?vue&type=script&lang=js"

import "./CreateInvoice.vue?vue&type=style&index=0&id=5f464d97&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f464d97"]])

export default __exports__